import { supabase } from "../../config/supabase";

// Get Challenges
const getMissionById = async (missionId) => {
    try {
        const { data, error } = await supabase.from('missions').select('*').eq('mission_id', missionId).single();
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting missions:',err);
        return { error: err, data:null };
    }
};

const getAllMissions = async (page,limit = 10) => {
    try {
        const { data, error } = await supabase.from('missions').select('*', { count: 'exact' }).range((page - 1) * limit, page * limit - 1); // Calculate range for pagination
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting missions:',err);
        return { error: err, data: null };
    }
};

const getAllMissionsIds = async () => {
    try {
        const { data, error } = await supabase.from('missions').select('mission_id,title') //.range((page - 1) * limit, page * limit - 1); // Calculate range for pagination
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting missions:',err);
        return { error: err, data: null };
    }
};

const getUnlinkedMissions = async () => {
    try {
        const { data, error } = await supabase.rpc('get_unlinked_missions'); // Only fetch missions that are not linked
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting missions:',err);
        return { error: err, data: null };
    }
  };
  

export { getMissionById, getAllMissions, getAllMissionsIds, getUnlinkedMissions };